import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { devicesAPI } from '../services/api';

function Devices() {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0 });
  const [filters, setFilters] = useState({
    serial_number: '',
    status: '',
  });

  useEffect(() => {
    fetchDevices();
  }, [pagination.page, filters]);

  const fetchDevices = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        limit: pagination.limit,
        ...filters,
      };

      Object.keys(params).forEach(key => {
        if (params[key] === '') delete params[key];
      });

      const response = await devicesAPI.getDevices(params);
      setDevices(response.data.data || []);
      setPagination(prev => ({ ...prev, total: response.data.total || 0 }));
    } catch (error) {
      console.error('Error fetching devices:', error);
      setDevices([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  return (
    <div>
      <div className="page-header">
        <h1>기기 관리</h1>
        <p>   기기 관리 및 상태 모니터링  </p>
      </div>

      <div className="card">
        <div className="filters">
          <div className="filter-item">
            <input
              type="text"
              className="form-control"
              placeholder="Search by serial number"
              value={filters.serial_number}
              onChange={(e) => handleFilterChange('serial_number', e.target.value)}
            />
          </div>
          <div className="filter-item">
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => handleFilterChange('status', e.target.value)}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="maintenance">Maintenance</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="loading">Loading devices...</div>
        ) : devices.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#7f8c8d' }}>
            No devices found
          </div>
        ) : (
          <>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Device Name</th>
                    <th>Serial Number</th>
                    <th>MAC Address</th>
                    <th>Firmware</th>
                    <th>Status</th>
                    <th>Active</th>
                    <th>Last Connected</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {devices.map((device) => (
                    <tr key={device.id}>
                      <td>{device.id}</td>
                      <td>{device.device_name || '-'}</td>
                      <td>{device.serial_number || '-'}</td>
                      <td>{device.mac_address || '-'}</td>
                      <td>{device.firmware_version || '-'}</td>
                      <td>
                        <span className={`badge ${device.status === 'active' ? 'badge-success' : 'badge-warning'}`}>
                          {device.status || 'unknown'}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${device.is_active ? 'badge-success' : 'badge-danger'}`}>
                          {device.is_active ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td>{device.last_connected_at ? new Date(device.last_connected_at).toLocaleDateString() : '-'}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          style={{ padding: '5px 10px', fontSize: '12px' }}
                          onClick={() => navigate(`/devices/${device.id}`)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                disabled={pagination.page === 1}
              >
                Previous
              </button>
              <span>
                Page {pagination.page} of {Math.ceil(pagination.total / pagination.limit) || 1}
              </span>
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                disabled={pagination.page >= Math.ceil(pagination.total / pagination.limit)}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Devices;